import { Box } from "@mui/material";
import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const statusCode = {
  400: "Ungültige Anfrage - Ihre Anfrage konnte nicht verarbeitet werden. Ursache dafür können fehlende URL-Paramter, unvollständige Anfragen oder fehlerhafte Syntax sein.",
  401: 'Unauthorisiert - Es konnte nicht verifiziert werden, ob Sie autorisiert sind, auf die URL "link" zuzugreifen. Entweder wurden falsche Referenzen (z.B. ein falsches Passwort) angegeben oder Ihr Browser versteht nicht, wie die geforderten Referenzen zu übermitteln sind. Sofern Sie für den Zugriff berechtigt sind, überprüfen Sie bitte die eingegebenen Zugangsdaten und versuchen Sie es erneut. Sofern Sie dies für eine Fehlfunktion des Servers halten, informieren Sie bitte den Webmaster hierüber.',
  404: "Angeforderte Ressource nicht gefunden - Die angeforderte URL konnte nicht gefunden werden. Sofern Sie die URL manuell eingegeben haben, überprüfen Sie bitte die Schreibweise und versuchen Sie es erneut. Sofern Sie dies für eine Fehlfunktion des Servers halten, informieren Sie bitte den Webmaster hierüber.",
  500: "Interner Server-Fehler - Der Server ist auf einen internen Fehler oder eine Fehlkonfiguration gestoßen und konnte Ihre Anfrage nicht abschließen. Bitte wenden Sie sich an den Serveradministrator unter geoportal@kreis-herford.de und teilen Sie ihm mit, wann dieser Fehler aufgetreten ist und welche Aktionen Sie kurz vor dem Fehler durchgeführt haben.",
  502: "Proxy Fehler - Der Server hat Eine ungültige Antwort eines anderen Servers erhalten und konnte Ihre Anfrage nicht abschließen. Bitte wenden Sie sich an den Serveradministrator unter geoportal@kreis-herford.de und teilen Sie ihm mit, wann dieser Fehler aufgetreten ist.",
};

const Error = () => {
  const navigate = useNavigate();
  const id = useParams().id;
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirectUrl");
  const errorMsg = statusCode[id] || "Fehler";
  return (
    <div>
      <h2 style={{ marginBottom: "10px", fontWeight: "600" }}>Fehler {id}</h2>
      <p>{errorMsg.replaceAll("link", redirect)}</p>
      <Box
        sx={{
          cursor: "pointer",
          padding: "5px",
          marginTop: "12px",
          textAlign: "center",
          borderRadius: 0,
          background: "#00568e",
          color: "white",
          border: "1px solid #00568e",
          maxWidth: "max-content",
          "&:hover": {
            background: "white",
            color: "#00568e",
          },
        }}
        onClick={() => navigate(`/`)}
      >
        zurück zur Übersicht
      </Box>
    </div>
  );
};

export default Error;
